<mat-card class="mat-elevation-z4 panel" cdkDrag>
    <mat-card-header class="header w-100" cdkDragHandle>
        <mat-card-title>
            <span>List of Images </span>
            <mat-form-field>
                <mat-label>Filter images...</mat-label>
                <input matInput (keyup)="filter($event)" placeholder="layer, project, orientation, date"
                       #input>
            </mat-form-field>
            <button class="close" matIconButton aria-label="Close" (click)="close()"><mat-icon>close</mat-icon></button>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="container">
        <div class="row ">
            <div class="form-container p-2">


                <div class="mat-elevation-z8">
                    <table class="table" mat-table [dataSource]="dataSource" matSort
                           multiTemplateDataRows>

                        <!-- LAYER Column -->
                        <ng-container matColumnDef="image_id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                            <td mat-cell *matCellDef="let row"> {{row.image_id}} </td>
                        </ng-container>
                        <!-- LAYER Column -->
                        <ng-container matColumnDef="layername">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Layer</th>
                            <td mat-cell *matCellDef="let row"> {{row.layername}} </td>
                        </ng-container>

                        <!-- Progress Column -->
                        <ng-container matColumnDef="projectname">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Project</th>
                            <td mat-cell *matCellDef="let row"> {{row.projectname}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="orientation">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Orientation</th>
                            <td mat-cell *matCellDef="let row" style="text-align: center"> {{row.orientation}} </td>
                        </ng-container>

                        <!-- Color Column -->
                        <ng-container matColumnDef="capture_date">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
                            <td mat-cell *matCellDef="let row"> {{row.capture_date | date :'MM/d/yyyy'}} </td>
                        </ng-container>

                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                                <div class="element-panel">
                                     <div class="element-detail">
                                        <div class="element-actions">
                                            <button matButton="elevated" color="primary"
                                                    (click)="paintImageFootprint(row)">Paint footprint
                                            </button>

                                            <button matButton="elevated" color="primary"
                                                    (click)="downloadMetadata(row)">Download metadata
                                            </button>
                                        </div>
                                        <div class="element-info">
                                            <div *ngFor="let item of row | keyvalue">
                                                <strong>{{item.key}}</strong>:{{item.value}}
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </td>
                        </ng-container>
                        <!-- Row shown when there is no matching data. -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                            class="element-row"
                            [class.expanded-row]="expandedElement === element"
                            (click)="expandedElement = expandedElement === element ? null : element"></tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                            class="detail-row"></tr>

                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                </div>
            </div>


        </div>
    </mat-card-content>
</mat-card>
